import Page from "../../../layout/Page";

import {useTranslation} from "react-i18next";
import usePagination from "../../../util/usePagination";
import categoryService from "../../../service/CategoryService";
import {DataTable} from "../../../components/DataTable";
import Container from '@mui/material/Container';
import ListPageActions from "../../../components/ListPageActions";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import AddButton from "../../../ui/AddButton";
import DeleteDialog from "../../../components/DeleteDialog";

const CategoryListPage = ({title}) => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [selected, setSelected] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const columns = [
        {
            name: "name",
            label: t('label.name'),
            searchable: true
        },
        {
            name: "application",
            label: t('label.application'),
            execute: (application) => application?.name
        }
    ];

    const categories = usePagination({
        service: categoryService
    })

    const ActionButtons = () => (
        <ListPageActions>
            <AddButton onClick={() => {
                navigate(`/commons/categories/create`)
            }}/>
        </ListPageActions>
    )

    return (
        <Page title={title}>
            <Container maxWidth={"md"}>
                <ActionButtons/>
                <DataTable
                    title={t('title.categoryList')}
                    columns={columns} {...categories}
                    onEdit={(item) => {
                        navigate(`/commons/categories/edit/${item._id}`);
                    }}
                    onDelete={(item) => {
                        setSelected(item);
                        setOpenDeleteDialog(true);
                    }}
                />
                <ActionButtons/>
            </Container>

            <DeleteDialog
                item={selected}
                itemService={categoryService}
                message={selected?.name}
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                    setSelected(null)
                }}
                onDoneCallback={categories.search}
            />
        </Page>
    );
}

export default CategoryListPage;
